module.exports = __webpack_public_path__ + "img/1528040045.45dd22eb.jpg";